// Frontend integration for email verification using Firebase Functions
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebase';
import { getLocale } from '../i18n';

// Initialize Firebase Functions
const functions = getFunctions(app, 'europe-west2');

/**
 * Send verification email to a user.
 *
 * `continueUrl` (optional) is where the user lands after verifying — pass the
 * web deal page so they return to the co-branded flow instead of the app store.
 */
export async function sendVerificationEmail(
  email: string,
  continueUrl?: string
): Promise<{
  success: boolean;
  message?: string;
  error?: string;
}> {
  try {
    const sendEmail = httpsCallable(functions, 'sendVerificationEmail');
    const result = await sendEmail({ email, continueUrl, language: getLocale() });

    console.log('[EmailVerification] Verification email sent response:', result);

    const data = result.data as any;

    return {
      success: data.success || false,
      message: data.message || 'Verification email sent successfully',
      error: data.error
    };
  } catch (error: any) {
    console.error('[EmailVerification] Error sending verification email:', error);
    return {
      success: false,
      error: error.message || 'Failed to send verification email'
    };
  }
}

/**
 * Email the user a magic link to download / open the mobile app. The link is a
 * Branch deep link (built via buildAppMagicLink) that opens the login screen
 * with their email pre-filled.
 */
export async function sendAppDownloadLink(
  email: string,
  link: string
): Promise<{ success: boolean; message?: string; error?: string }> {
  try {
    const send = httpsCallable(functions, 'sendAppDownloadLink');
    const result = await send({ email, link, language: getLocale() });
    const data = result.data as any;
    return {
      success: data.success || false,
      message: data.message,
      error: data.error,
    };
  } catch (error: any) {
    console.error('[EmailVerification] Error sending app download link:', error);
    return { success: false, error: error.message || 'Failed to send app download link' };
  }
}
